<template>
  <div id="pageRoot">
    <span class="normalTheme pageInstruction" style="left: 90px; top: 70px">
      <p>Señala dónde está escrito el nombre del instrumento.</p>
    </span>

    <img
      style="width: 180px; top: 220px; left: 30px"
      class="pageElement basicItem01"
      src="/pages/img/sordovio/assets_p14/piano.svg"
    />

    <div id="radio0">
      <label
        class="toggleButtonContainer pageElement"
        style="width: 42.89px; height: 42.89px; left: 223px; top: 190px"
        >PIANO
        <input type="radio" name="piano" disabled checked="true" />
        <span class="toggleButton"></span>
      </label>
      <label
        class="toggleButtonContainer pageElement"
        style="width: 42.89px; height: 42.89px; left: 223px; top: 243px"
        >PIOLA
        <input type="radio" name="piano" disabled />
        <span class="toggleButton"></span>
      </label>
      <label
        class="toggleButtonContainer pageElement"
        style="width: 42.89px; height: 42.89px; left: 223px; top: 296px"
        >PINO
        <input type="radio" name="piano" disabled />
        <span class="toggleButton"></span>
      </label>
    </div>

    <img
      style="width: 170px; top: 480px; left: 30px"
      class="pageElement basicItem01"
      src="/pages/img/sordovio/assets_p14/tambor.svg"
    />

    <div id="radio1">
      <label class="toggleButtonContainer pageElement" id="toggle11"
        >GUISO
        <input
          type="radio"
          name="guitarra"
          ref="1-1"
          v-on:change="saveOption('radios', 1, 1)"
          :onload="loadOption('radios', 1, 1)"
        />
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" id="toggle12"
        >GUITARRA
        <input
          type="radio"
          name="guitarra"
          ref="1-2"
          v-on:change="saveOption('radios', 1, 2)"
          :onload="loadOption('radios', 1, 2)"
        />
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" id="toggle13"
        >GUIRNALDA
        <input
          type="radio"
          name="guitarra"
          ref="1-3"
          v-on:change="saveOption('radios', 1, 3)"
          :onload="loadOption('radios', 1, 3)"
        />
        <span class="toggleButton"></span>
      </label>
    </div>

    <img
      style="width: 170px; top: 190px; left: 500px"
      class="pageElement basicItem01"
      src="/pages/img/sordovio/assets_p14/guitarra.svg"
    />

    <div id="radio2">
      <label class="toggleButtonContainer pageElement" id="toggle21"
        >TAMBO
        <input
          type="radio"
          name="tambor"
          ref="2-1"
          v-on:change="saveOption('radios', 2, 1)"
          :onload="loadOption('radios', 2, 1)"
        />
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" id="toggle22"
        >TAMBOR
        <input
          type="radio"
          name="tambor"
          ref="2-2"
          v-on:change="saveOption('radios', 2, 2)"
          :onload="loadOption('radios', 2, 2)"
        />
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" id="toggle23"
        >TAMBIÉN
        <input
          type="radio"
          name="tambor"
          ref="2-3"
          v-on:change="saveOption('radios', 2, 3)"
          :onload="loadOption('radios', 2, 3)"
        />
        <span class="toggleButton"></span>
      </label>
    </div>

    <div
      class="textBubble"
      style="width: 380px; height: 250px; left: 550px; top: 440px"
    >
      <div
        class="textContainer textBase center"
        style="width: 90%; height: 90%"
      >
        <p class="center" style="font-size: 30px">
          ¡Presta atención!<br /><br />Las palabras son muy similares y las
          puedes confundir.
        </p>
      </div>
      <img
        class="arrow left"
        src="/pages/img/general/textBubbleArrow.svg"
        style="top: 240px; left: 200px"
      />
    </div>
  </div>
</template>
<style scoped>
#toggle11 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 710px;
  top: 186px;
}
#toggle12 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 710px;
  top: 240px;
}
#toggle13 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 710px;
  top: 293px;
}
#toggle21 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 223px;
  top: 497px;
}
#toggle22 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 223px;
  top: 551px;
}
#toggle23 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 223px;
  top: 604px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["vio/Video 45.mp4", "vio/Video 46c.mp4", "vio/Video 47.mp4"],
    };
  },
  methods: {
    dbId(name, group) {
      return `${this.$parent.pageID()}-${name}-${group}`;
    },
    async loadOption(name, group, option) {
      var id = this.dbId(name, group);

      var value = await this.$db.options
        .get({
          id: id,
        })
        .catch(function (error) {
          console.log("error getting option" + error);
        });
      if (value === undefined) return;
      console.log(value);

      this.$refs[group + "-" + option].checked = value.option == option;

      console.log(
        "option loaded: " +
          id +
          ", option:" +
          option +
          ", selected:" +
          value.option
      );
    },
    saveOption(name, group, option) {
      var id = this.dbId(name, group);

      this.$db.options
        .put({
          id: id,
          option: option,
        })
        .catch(function (error) {
          console.log("error saving option" + error);
        });

      console.log("option saved: " + id + ", " + option);
    },
  },
};
</script>